import { DEFAULT_PAGE_SIZE } from 'config/constants';
import { useCurrentPageQuery } from 'helpers/queryParams/useCurrentPageQuery';
import { useDomainConfig } from 'hooks/useDomainConfig';
import { useEffect, useRef } from 'react';
import { ListedProductType } from 'types/product';
import { getGtmProductsListEvent, getNewGtmEcommerceEvent } from 'utils/Gtm/EventFactories';
import { gtmSafePushEvent } from 'utils/Gtm/Gtm';

export const useGtmSearchResultsListView = (products: ListedProductType[], searchQuery: string): void => {
    const lastSearchQuery = useRef<string | undefined>(undefined);
    const lastViewedSearchPage = useRef<number | undefined>(undefined);
    const { url } = useDomainConfig();
    const currentPage = useCurrentPageQuery();

    useEffect(() => {
        if (lastSearchQuery.current !== searchQuery || lastViewedSearchPage.current !== currentPage) {
            lastSearchQuery.current = searchQuery;
            lastViewedSearchPage.current = currentPage;
            const event = getNewGtmEcommerceEvent('ec.products_list', true);
            event.ecommerce = getGtmProductsListEvent(products, 'search result', currentPage, DEFAULT_PAGE_SIZE, url);
            gtmSafePushEvent(event);
        }
    }, [searchQuery, currentPage, products, url]);
};
